import React from 'react';
import './CompetitionTypePill.css';

export type CompetitionType =
  | 'csv'
  | 'image'
  | 'pdf'
  | 'code'
  | 'video'
  | 'html'
  | 'github'
  | 'txt'
  | 'viz'
  | 'multi'
  | 'other';

function normalizeType(input?: string | null): CompetitionType {
  const raw = (input || '').trim().toLowerCase();
  if (!raw) return 'other';

  // Common aliases
  if (raw === 'text') return 'txt';
  if (raw === 'png' || raw === 'jpg' || raw === 'jpeg' || raw === 'gif' || raw === 'bmp' || raw === 'tiff') {
    return 'image';
  }
  if (raw === 'mp4' || raw === 'mov' || raw === 'webm') return 'video';
  if (raw === 'py' || raw === 'ipynb' || raw === 'js' || raw === 'ts' || raw === 'java' || raw === 'cpp' || raw === 'c') {
    return 'code';
  }
  if (raw === 'tsv') return 'csv';

  const known: CompetitionType[] = ['csv', 'image', 'pdf', 'code', 'video', 'html', 'github', 'txt', 'viz', 'multi', 'other'];
  return known.includes(raw as CompetitionType) ? (raw as CompetitionType) : 'other';
}

function labelForType(t: CompetitionType): string {
  switch (t) {
    case 'csv':
      return 'CSV';
    case 'image':
      return 'Image';
    case 'pdf':
      return 'PDF';
    case 'code':
      return 'Code';
    case 'video':
      return 'Video';
    case 'html':
      return 'HTML';
    case 'github':
      return 'GitHub';
    case 'txt':
      return 'Text';
    case 'viz':
      return 'Viz';
    case 'multi':
      return 'Multi';
    default:
      return 'Other';
  }
}

export interface CompetitionTypePillProps {
  type?: string | null;
  className?: string;
  titlePrefix?: string;
}

const CompetitionTypePill: React.FC<CompetitionTypePillProps> = ({
  type,
  className = '',
  titlePrefix = 'Competition type',
}) => {
  const normalized = normalizeType(type);
  const label = labelForType(normalized);

  return (
    <span
      className={`competition-type-pill competition-type-pill--${normalized} ${className}`.trim()}
      title={`${titlePrefix}: ${label}`}
    >
      {label}
    </span>
  );
};

export default CompetitionTypePill;
